'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _makeResourceTypeReducer = require('../utils/services/http/resources/reducers/makeResourceTypeReducer');

var _makeResourceTypeReducer2 = _interopRequireDefault(_makeResourceTypeReducer);

var _resourceConstants = require('../utils/services/http/resources/resourceConstants');

var _elementConstants = require('../../common/elements/elementConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Constants
var elementsPredicateFn = function elementsPredicateFn(action) {
    return action.resource === _resourceConstants.RESOURCE_TYPES.elements || action.resource === _resourceConstants.RESOURCE_TYPES.boards && action.type !== _resourceConstants.RESOURCES_MARKED_AS_STALE || action.type === _elementConstants.ELEMENT_CREATE;
}; // Reducers
exports.default = (0, _makeResourceTypeReducer2.default)(_resourceConstants.RESOURCE_TYPES.elements, elementsPredicateFn);


//////////////////
// WEBPACK FOOTER
// ./src/client/element/elementsResourceTypeReducer.js
// module id = 1978
// module chunks = 0